import { EventEmitter, Injectable, Output, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Experience, AppStatus, Item, Ost, User } from '../models';
import { TranslateService } from '@ngx-translate/core';
import { Observer } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable()

export class GeolocationService {

    @Output() changeCurrentPosition = new EventEmitter<Position>();
    @Output() seeCurrentPosition = new EventEmitter<Position>();
    watchID: number;

    constructor(
    ) {
        this.watchID = null;
    }
    /**
     * ottieni la posizione corrente attravrso il navigator
     */
    getPosition() {
        // console.log("getPosition");
        navigator.geolocation.getCurrentPosition(
            (position: Position) => {
                // console.log(position);
                this.seeCurrentPosition.emit(position);
            },
            (error: PositionError) => {
                // console.log('Geolocation service: ' + error.message);
            }, { timeout: 4000, enableHighAccuracy: true }
        );
    }
    /**
     * si ottiene il tracciamento attraverso la geolocalizzazione 
     */
    trackMe() {
        // console.log("trackMe");
        // this.stopTrackMe();
        if (this.watchID === null) {
            this.watchID = navigator.geolocation.watchPosition(
                (position: Position) => {
                    this.changeCurrentPosition.emit(position);
                },
                (error: PositionError) => {
                    // console.log('Geolocation service: ' + error.message);
                },
                { enableHighAccuracy: true, maximumAge: 3000, timeout: 5000 }
            );
        }
    }

    /**
     * si ferma il tracciamento attraverso la geolocalizzazione 
     */
    stopTrackMe() {
        if (this.watchID) {
            navigator.geolocation.clearWatch(this.watchID);
            this.watchID = null;
        }
    }
}
